import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authService } from "./userService";
import { toast } from "react-toastify"

// Register
export const register = createAsyncThunk("auth/register", async (userData, thunkAPI) => {
    try {
        return await authService.register(userData)
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

// Login
export const login = createAsyncThunk("auth/login", async (userData, thunkAPI) => {
    try {
        return await authService.login(userData)
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

// Get User Profile
export const userProfile = createAsyncThunk("user/profile", async (thunkAPI) => {
    try {
        return await authService.userProfile()
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})


const getUserFromLocalStorage = localStorage.getItem("user") 
    ? JSON.parse(localStorage.getItem("user")) 
    : null

const initialState = {
    user: getUserFromLocalStorage,
    token: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
}

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: (state, action) => {
            state.token = null
            localStorage.clear()
        }
    },
    extraReducers: (builder) => {
        builder
            // Register
            .addCase(register.pending, (state) => {
                state.isLoading = true
            })
            .addCase(register.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.isSuccess = true
                state.registerUser = action.payload
                if (state.isSuccess === true) {
                    toast.info("User Register Successfully")
                }
            })
            .addCase(register.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.error
                if (state.isError === true) {
                    toast.error(action.error)
                }
            })

            // Login
            .addCase(login.pending, (state) => {
                state.isLoading = true
            })
            .addCase(login.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.isSuccess = true
                state.user = action.payload
                if (state.isSuccess === true) {
                    localStorage.setItem("token", action.payload.token)
                    toast.info("User Logged In Successfully")
                }
            })
            .addCase(login.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.error
                if (state.isError === true) {
                    toast.error(action.error)
                }
            })

            // Get User Profile
            .addCase(userProfile.pending, (state) => {
                state.isLoading = true
            })
            .addCase(userProfile.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.isSuccess = true
                state.user = action.payload
            })
            .addCase(userProfile.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.isSuccess = false
                state.message = action.error
            })

    }
})

export const {logout} = authSlice.actions

export default authSlice.reducer
